import { render } from "./CupCuponsView.vue?vue&type=template&id=c5e2c980&scoped=true"
import script from "./CupCuponsView.vue?vue&type=script&lang=js"
export * from "./CupCuponsView.vue?vue&type=script&lang=js"

import "./CupCuponsView.vue?vue&type=style&index=0&id=c5e2c980&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Induscapas\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5e2c980"]])

export default __exports__